import { defineStore } from 'pinia'
import { ref, markRaw } from 'vue'

export const useSdkStore = defineStore('sdk', () => {
  // SDK 实例
  const desginsdk = ref<any>(null)

  // 设置 SDK 实例
  const setSdk = (sdk: any) => {
    desginsdk.value = sdk
  }

  // 获取 SDK 实例
  const getSdk = () => {
    return desginsdk.value
  }

  // 检查 SDK 是否已初始化
  const isInitialized = () => {
    return desginsdk.value !== null
  }

  return {
    desginsdk,
    setSdk,
    getSdk,
    isInitialized
  }
})